export default {
	active: "Actif",
	createdBy: "Créé par {name}",
	dialogTitle: "Messages actifs",
	hiddenContent: "Contenu protégé — cliquez sur afficher pour lire",
	hideResolved: "Masquer les messages résolus",
	hideShort: "Masquer",
	noResolvedMessages: "Aucun message résolu",
	privacyNote: "En fermant, tous les messages redeviennent masqués.",
	revealShort: "Afficher",
	showResolved: "Afficher les messages résolus",
	view: "Voir",
	viewMessages: "Voir les messages",
	form: {
		messageLabel: "Message",
		messagePlaceholder: "Décrivez le message...",
		severityLabel: "Gravité",
		typeLabel: "Type",
	},
	messages: {
		createError: "Erreur lors de la création du message",
		created: "Message créé avec succès",
		deleteError: "Erreur lors de la suppression du message",
		deleted: "Message supprimé",
		loadError: "Erreur lors du chargement des messages",
		resolveError: "Erreur lors de la résolution du message",
		resolved: "Message résolu",
	},
	newMessage: "Nouveau message",
	noMessages: "Aucun message",
	resolve: "Résoudre",
	resolved: "Résolu",
	resolvedBy: "Résolu par {name} le {date}",
	severity: {
		CRITICAL: "Critique",
		LOW: "Faible",
		NORMAL: "Normal",
	},
	title: "Messages",
	type: {
		ALERT: "Alerte",
		NOTE: "Note",
		PENDENCY: "Pendance",
		REPLENISHMENT: "Réapprovisionnement",
	},
};
